export const MODES = {
  PER_DAY: 'perDay',
  PER_WEEK: 'perWeek'
};

export const ISO_DAY_NUMBERS = [1, 2, 3, 4, 5, 6, 7];

export const DAY_NAMES = {
  1: 'Maandag',
  2: 'Dinsdag',
  3: 'Woensdag',
  4: 'Donderdag',
  5: 'Vrijdag',
  6: 'Zaterdag',
  7: 'Zondag'
};

export const DAILY_LIMIT_MIN = 0;
export const DAILY_LIMIT_MAX = 24;
export const WEEKLY_LIMIT_MIN = 0;
export const WEEKLY_LIMIT_MAX = 168;
export const LIMIT_STEP = 0.01;
export const PERCENTAGE_MIN = 100;
export const PERCENTAGE_MAX = 999;
export const LABEL_MAX_LENGTH = 50;

export const createEmptyEntry = () => ({
  shift_allowance_percentage: 100,
  overtime_percentage: 100,
  label: ''
});

export const createEmptyDayEntries = () => {
  const days = {};

  ISO_DAY_NUMBERS.forEach((dayNumber) => {
    days[dayNumber] = [createEmptyEntry()];
  });

  return days;
};

export const createDefaultSettings = () => ({
  mode: null,
  limit: null,
  days: createEmptyDayEntries()
});

const sanitizeEntry = (entry) => ({
  shift_allowance_percentage: toFiniteNumberOrNull(entry && entry.shift_allowance_percentage),
  overtime_percentage: toFiniteNumberOrNull(entry && entry.overtime_percentage),
  label: typeof (entry && entry.label) === 'string' ? entry.label : ''
});

function toFiniteNumberOrNull(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
}

export const normalizeSettings = (settings) => {
  const normalized = createDefaultSettings();

  if (!settings || typeof settings !== 'object') {
    return normalized;
  }

  if (settings.mode === MODES.PER_DAY || settings.mode === MODES.PER_WEEK) {
    normalized.mode = settings.mode;
  }

  const normalizedLimit = toFiniteNumberOrNull(settings.limit);

  if (normalizedLimit !== null) {
    normalized.limit = normalizedLimit;
  }

  const sourceDays = settings.days || {};

  ISO_DAY_NUMBERS.forEach((dayNumber) => {
    const dayEntries = Array.isArray(sourceDays[dayNumber])
      ? sourceDays[dayNumber]
      : (Array.isArray(sourceDays[String(dayNumber)]) ? sourceDays[String(dayNumber)] : []);

    normalized.days[dayNumber] = dayEntries.length
      ? dayEntries.map((entry) => sanitizeEntry(entry))
      : [createEmptyEntry()];
  });

  return normalized;
};
